import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { ProductVariation } from 'models/productsReferential';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { useEssentialWorkspaceActiveTabId } from 'state/workspaces/essential/hooks';
import { submitProductSelectionEssentialWorkspaceThunk } from 'state/workspaces/essential/thunks';
import { getProductNameForAnalytics } from 'utils/productVariation';

export function useInitEssentialForm() {
  const tabId = useEssentialWorkspaceActiveTabId();

  const dispatch = useThunkDispatch();

  const initEssentialForm = (product: ProductVariation) => {
    if (tabId) {
      logAnalytics.trackEvent(
        'Primary market essential product selector',
        'Select a product',
        getProductNameForAnalytics(product),
      );
      dispatch(submitProductSelectionEssentialWorkspaceThunk(tabId, product));
    }
  };

  return { initEssentialForm };
}
